/* eslint-disable react/display-name */
import React, {
  useEffect,
  useState,
  createRef,
  useImperativeHandle,
  forwardRef,
} from 'react';
import { CustomCheckbox } from './CustomCheckbox';

export const CheckboxGroup = forwardRef(
  (
    {
      options,
      labelKey = 'label',
      idKey = 'id',
      onChange,
      customFont = false,
      ...rest
    },
    ref
  ) => {
    useImperativeHandle(ref, () => ({
      groupReset() {
        refOptions.map((o) => {
          o.ref.current.customReset();
        });
        setSelectedOptions([]);
      },
      setInitialValue(values) {
        setInitialValues(values);
      },
    }));
    const [isDirty, setIsDirty] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [initialValues, setInitialValues] = useState();
    const [refOptions, setRefOptions] = useState([]);

    useEffect(() => {
      if (!isDirty) setIsDirty(true);
    }, []);

    useEffect(() => {
      if (options) {
        const _refOptions = options.map((o) => ({
          option: o,
          ref: createRef(),
        }));
        setRefOptions(_refOptions);
      }
    }, [options]);

    useEffect(() => {
      if (refOptions && initialValues) {
        const selected = refOptions
          .filter((o) => initialValues.includes(o.option[idKey]))
          .map((o) => o.option);
        setSelectedOptions(selected);
      }
    }, [refOptions, initialValues]);

    useEffect(() => {
      if (isDirty) onChange && onChange(selectedOptions);
    }, [selectedOptions]);

    const handleSelect = (opt, e) => {
      const isChecked = e.target.checked;
      let selections = [];
      if (isChecked) {
        selections = [...selectedOptions, opt];
      } else {
        selections = selectedOptions.filter(
          (o) => o[`${idKey}`] !== opt[`${idKey}`]
        );
      }
      setSelectedOptions(selections);
    };

    return (
      <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
        {refOptions?.map((item) => {
          const opt = item.option;
          return (
            <CustomCheckbox
              ref={item.ref}
              key={opt[`${idKey}`]}
              onClick={(e) => handleSelect(opt, e)}
              label={opt[`${labelKey}`]}
              customFont={customFont}
              isSelected={
                !!selectedOptions.find(
                  (o) => opt[`${idKey}`] === o?.[`${idKey}`]
                )
              }
              {...rest}
            />
          );
        })}
      </div>
    );
  }
);
